"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asCrossChainHeaders = exports.asBorrowChainId = exports.asCoreChainId = exports.asSupportedChainId = void 0;
const sanitizers_1 = require("@restless/sanitizers");
exports.asSupportedChainId = (0, sanitizers_1.asEnum)(['1', '4', '137', '80001'], 'SupportedChainId');
exports.asCoreChainId = (0, sanitizers_1.asEnum)(['1', '4'], 'CoreChainId');
exports.asBorrowChainId = (0, sanitizers_1.asEnum)(['80001'], 'BorrowChainId');
exports.asCrossChainHeaders = (0, sanitizers_1.asObject)({ chainid: (0, sanitizers_1.asOptional)(exports.asSupportedChainId) });
//# sourceMappingURL=asCrossChain.js.map